import store from "@/store";

export default {
	install(Vue, options) {
		Vue.prototype.CONFIG = {
			UPLOAD_API: process.env.AUTHOR_API + '/authors/upload/tempdir',
		}
	}
}



// WEBPACK FOOTER //
// ./src/config.js